























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";
import UpsellModal from "@/components/UpsellModal.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { FadeTransition } from "vue2-transitions";
import HeaderWeShope from "@/components/HeaderWeShope.vue";
import FooterWeShope from "@/components/FooterWeShope.vue";
import { isWishope } from "./common/utils";

const AppProps = Vue.extend({
  computed: {
    ...mapState("global", ["globalLoading"]),
    ...mapGetters('vas', [
      'merchant',
      'isEnabled',
    ]),
  },
  methods: {
    ...mapActions("global", ["fetchCart"]),
    isWishope,
  },
});

@Component({
  components: {
    Header,
    FadeTransition,
    Loader,
    UpsellModal,
    Footer,
    HeaderWeShope,
    FooterWeShope,
  },
})
export default class App extends AppProps {
  created() {
    this.fetchCart();

    document.title = isWishope() ? "Wishope" : "Tinaba Easy Shop";

    if(isWishope())
    {
      document.body.classList.add('wishope');
      document.getElementById('theme-color')?.setAttribute('content', '#00654C');
      /*
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        document.createElement('link').rel = 'icon';
        document.head.appendChild(link);
      }
      document.querySelector("link[rel~='icon']").href = '/favicon-wishope.png';
      */
    }

    console.log('vas.merchant', this.merchant);
  }
}
